import httpService from "V2.0/services/httpService";

export {
  getConfiguration,
  registerConfiguration,
  updateConfiguration,
  deleteConfiguration,
  getMCubeEngageWhatsappTemplates,
  addToMCubeWhatsAppThread,
  GetConfigurationRequest,
  UpdateConfigurationRequest,
  DeleteConfigurationRequest,
  RegisterConfigurationRequest,
  GetTemplatesRequest,
  AddToMCubeWhatsAppThreadRequest,
};

const routes = {
  getConfiguration: "/mcubeengage/manage/whitelabelConfig",
  registerConfiguration: "/mcubeengage/manage/whitelabelRegister",
  updateConfiguration: "/mcubeengage/manage/whitelabelConfig",
  deleteConfiguration: "/mcubeengage/manage/whitelabelDeleteConfig",
  getTemplates: "/mcubeengage/manage/whitelabelGetTemplates",
  addToWhatsappThread: "/mcubeengage/manage/whitelabelAddToWhatsAppThread",
};

interface GetConfigurationRequest {
  params: {
    workspaceId: string;
  };
}

function getConfiguration(request: GetConfigurationRequest) {
  return httpService.get(
    `${routes.getConfiguration}/${request.params.workspaceId}`,
  );
}

interface RegisterConfigurationRequest {
  params: { workspaceId: string };
  body: {
    mcubeApiKey: string;
    phoneNumbers: Array<string>;
    apiBaseUrl: string;
  };
}

function registerConfiguration(request: RegisterConfigurationRequest) {
  const { params, body } = request;
  return httpService.post(
    `${routes.registerConfiguration}/${params.workspaceId}`,
    body,
  );
}

interface UpdateConfigurationRequest {
  params: { workspaceId: string };
  body: {
    mcubeApiKey?: string;
    phoneNumbers?: Array<string>;
    apiBaseUrl?: string;
  };
}

function updateConfiguration(request: UpdateConfigurationRequest) {
  const { params, body } = request;

  return httpService.put(
    `${routes.updateConfiguration}/${params.workspaceId}`,
    body,
  );
}

interface DeleteConfigurationRequest {
  params: { workspaceId: string };
}

function deleteConfiguration(request: DeleteConfigurationRequest) {
  const { params } = request;

  return httpService.delete(
    `${routes.deleteConfiguration}/${params.workspaceId}`,
  );
}

interface GetTemplatesRequest {
  params: { workspaceId: string };
}

function getMCubeEngageWhatsappTemplates(request: GetTemplatesRequest) {
  const { params } = request;

  return httpService.get(`${routes.getTemplates}/${params.workspaceId}`);
}

interface AddToMCubeWhatsAppThreadRequest {
  params: { workspaceId: string; assistantId: string };
  body: { toNumber: string; message: string };
}

function addToMCubeWhatsAppThread(request: AddToMCubeWhatsAppThreadRequest) {
  const { params, body } = request;
  return httpService.post(
    `${routes.addToWhatsappThread}/${params.workspaceId}/${params.assistantId}`,
    body,
  );
}
